import { Button, ButtonProps, Spinner, Tooltip } from '@primer/react';
import clsx from 'clsx';
import { useMemo } from 'react';

interface IMyButtonProps extends ButtonProps {
    text?: string,
    isLoading?: boolean,
    apiAuthorized?: string,
    apiAuthorizedMethod?: "GET" | "PUT" | "POST" | "DELETE",
    iconClass?: string,
    tooltip?: string,
    tooltipdDirection?: 'n' | 'ne' | 'e' | 'se' | 's' | 'sw' | 'w' | 'nw',
}
const Loading = () => {
    return <Spinner size='small' />
}
const MyButton = (props: IMyButtonProps) => {

    const isAuthorized = useMemo(() => {
        return true;
    }, [props.apiAuthorized])
    const Icon = () => {
        return (
            <i className={clsx(props.icon)}></i>
        );
    }
    const getLeadingVisual = () => {
        if (props.leadingVisual) return props.leadingVisual
        if (props.isLoading) return Loading
        if (props.iconClass) return Icon
        return undefined;
    }
    return (
        <>
            {isAuthorized &&
                <>

                    {!props.tooltip &&
                        <Button
                            {...props}
                            size={props.size ?? "small"}
                            leadingVisual={(props.isLoading) ? Loading : props.leadingVisual}
                            disabled={props.isLoading || props.disabled || !isAuthorized}
                        >
                            {props.text ?? ""}
                            {props.children}
                        </Button>
                    }
                    {props.tooltip &&
                        <Tooltip aria-label={props.tooltip} direction={props.tooltipdDirection ?? 'n'}>

                            <Button
                                {...props}
                                size={props.size ?? "small"}
                                leadingVisual={(props.isLoading) ? Loading : props.leadingVisual}
                                disabled={props.isLoading || props.disabled || !isAuthorized}
                            >
                                {props.text ?? ""}
                                {props.children}
                            </Button>
                        </Tooltip>

                    }
                </>
            }
            {!isAuthorized &&
                <Tooltip aria-label="Unauthorized" direction='s'>
                    <Button
                        {...props}
                        size={props.size ?? "small"}
                        leadingVisual={getLeadingVisual()}
                        disabled={props.isLoading || props.disabled || !isAuthorized}
                    >
                        {props.text ?? ""}
                        {props.children}
                    </Button>
                </Tooltip>
            }
        </>

    );
};


export default MyButton;